<!-- 通知公告模板 -->
<template>
  <div class="cm_notice_container">
    <!-- 标题 -->
    <div class="cm_notice_title">
      <h3>{{data.name}}</h3>
      <router-link :to="{path:'/list',query:{urlData:JSON.stringify(data)}}">MORE+</router-link>
    </div>
    <!-- 内容 -->
    <div  v-loading="loading" style="min-height:280px">
      <ul class="cm_work_content">
        <li v-for="item in dataList" :key="item.NEWS_ID" @click="toDetail(item.NEWS_ID,data)">
          <h4>{{item.TITLE}}</h4>
          <span>{{cutDate(item.PUBLISH_DATE)}}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props:["data"],
  data() {
    //这里存放数据
    return {
      url:this.data.url,
      dataList:[],
      loading:true
    };
  },
  //监听属性 类似于data概念
  computed: {
    cutDate:function(date){
      return (date)=>date.substring(5)
    }
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    httpPost() {
      this.loading = true
      this.$http({
        url: this.$http.adornUrl(this.$store.state.comUrl),
        method: 'post',
        data: this.data.data 
      }).then(({ data }) => {
        if(data.data!=''&&data.data!=undefined&&data.data!=null){
          this.dataList = data.data.pdList
          this.loading = false
        }
          
      });
    },
    toDetail(ID,data){
      this.$router.push({path:'/detail/'+ID,query: {parentData:JSON.stringify(data)}})
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.httpPost()
  },
};
</script>
<style scoped>
.cm_notice_container {
  width: 390px;
  height: 308px;
  background: rgba(255, 255, 255, 1);
  overflow: hidden;
  border: 1px solid rgba(225, 228, 231, 1);
  padding: 0 20px;
  margin-top: 20px;
}

.cm_notice_title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  border-bottom: 1px solid #4379d3;
}
.cm_notice_title > h3 {
  font-size: 20px;
  font-weight: 500;
  color: rgba(67, 121, 211, 1);
  line-height: 33px;
}
.cm_work_content > li {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 36px;
  cursor:pointer;
}
.cm_work_content > li :hover{
  color:#4379d3;
}

.cm_work_content > li >h4{
  width: 86%;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  font-size:16px;
  color:rgba(0,0,0,1);
  font-weight:400;
}
.cm_work_content > li >span{
  font-size:16px;
  font-weight:400;
  color:rgba(191,191,191,1);
}
</style>